import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import CustomButton from "../../components/Buttons/Button";
import IposTable from "../../components/dashboard/ipos/IposTable";
import { getIpos } from "../../store/actions/ipos/getIpos";

function Ipos() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getIpos());
  }, [dispatch]);

  return (
    <DashboardLayout>
      <div className="px-4 md:px-8">
        <div className="flex items-center mb-4 md:flex-row md:items-center w-full">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-1" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-1" />
          <div className="font-semibold text-[#475467] text-sm sm:text-base bg-[#F9FAFB] p-1 px-3 rounded-md">
            IPO Management
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center border-b border-b-[#EAECF0] md:items-center mb-6">
          <h1 className="font-semibold text-xl md:text-2xl">Halal Stock IPOs</h1>
          <CustomButton
            variant="contained"
            customColor="#159AA8"
            children="Create IPO"
            width="220px"
            height="45px"
            padding="10px"
            margin="15px 0"
            color="#fff"
            onClick={() => navigate("/ipos/create")}
          />
        </div>

        <div className="mt-4">
          <IposTable />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Ipos;
